<template>
    <div class="container mx-auto bg-gray-200 pb-20">
        <div class="px-2 md:px-6 text-lg font-bold mt-10">{{ $t("loggingOut") }}</div>
    </div>
</template>

<script>
    export default {
        components: {},
        mounted() {
            this.$cleanLogin();
            this.$router.push('/login');
        },
    }
</script>


